import { PlugToken } from './common'
import { SwapProvider } from './swapInterface'

export const KNOWN_ACTIVITY_KINDS = [
  'Transfer',
  'Approve',
  'Burn',
  'Mint',
  'swap',
  'bridge',
  'withdraw',
  'deposit',
] as const

export type PlugUserActivityKind = (typeof KNOWN_ACTIVITY_KINDS)[number]

interface PlugUserActivityBase {
  id: string
  state: 'confirmed' | 'pending'
  kind: PlugUserActivityKind
  isOutgoing: boolean
  isSwap: boolean
  link: string | null
  timestamp: Date
  provider: string
}

interface TransactionActivityBase extends PlugUserActivityBase {
  sent: {
    token: PlugToken
    amount: bigint
    transactionId: string
  }
  isSwap: false
}

interface TransferActivity extends TransactionActivityBase {
  kind: 'Transfer'
  from: string
  to: string
}

interface ApproveActivity extends TransactionActivityBase {
  kind: 'Approve'
  from: string
  to: string
}

interface BurnActivity extends TransactionActivityBase {
  kind: 'Burn'
  from: string
}

interface MintActivity extends TransactionActivityBase {
  kind: 'Mint'
  to: string
}

interface DepositActivity extends TransactionActivityBase {
  kind: 'deposit'
  from: string
}

interface WithdrawActivity extends TransactionActivityBase {
  kind: 'withdraw'
  to: string
}

export type SwapActivity = PlugUserActivityBase & {
  isSwap: true
  provider: SwapProvider
  kind: 'swap' | 'bridge'
  sent: {
    token: PlugToken
    amount: bigint
    amountUsd: number | null
    transactionId: string | null
  }
  received: {
    token: PlugToken
    amount: bigint
    amountUsd: number | null
    transactionId: string | null
  }
}

export type PlugUserActivity =
  | TransferActivity
  | ApproveActivity
  | BurnActivity
  | MintActivity
  | DepositActivity
  | WithdrawActivity
  | SwapActivity
